import '../adventure.css';
import { useTranslation } from 'react-i18next';
import Option from './Option';
import Burns from '../../../assets/designSystem/icons/firstAid/FirstAid/Burns.png';
import Chocking from '../../../assets/designSystem/icons/firstAid/FirstAid/Chocking.png';
import Cuts from '../../../assets/designSystem/icons/firstAid/FirstAid/Cuts.png';
import Fractures from '../../../assets/designSystem/icons/firstAid/FirstAid/Fractures.png';
import Nosebleeding from '../../../assets/designSystem/icons/firstAid/FirstAid/Nosebleeding.png';

export default function FirstAid() {
  const { t } = useTranslation();
  const options = [
    {
      label: t('staticPages.homePageChild.cards.firstAid.choking'),
      image: Chocking,
      color: '#ff2a26',
      className: 'left__top',
      to: 'choking',
    },
    {
      label: t('staticPages.homePageChild.cards.firstAid.burnsAndScalds'),
      image: Burns,
      color: '#FF8C00',
      className: 'top__right',
      to: 'burns',
    },
    {
      label: t('staticPages.homePageChild.cards.firstAid.fractures'),
      image: Fractures,
      color: '#ffc631',
      className: 'left__middle',
      to: 'fractures',
    },
    {
      label: t('staticPages.homePageChild.cards.firstAid.noseBleeding'),
      image: Nosebleeding,
      color: '#14c7c4',
      className: 'right__lower',
      to: 'nose-bleeding',
    },
    {
      label: t('staticPages.homePageChild.cards.firstAid.cutsAndWounds'),
      image: Cuts,
      color: '#3a8ace',
      className: 'left__bottom2',
      to: 'cuts-wounds',
    },
  ];
  return (
    <div className="map__container">
      <svg
        className="connector__svg"
        xmlns="http://www.w3.org/2000/svg"
        width="102"
        height="266"
        viewBox="0 0 102 266"
        fill="none"
      >
        <path
          d="M18.8542 263.308C8.06129 257.075 0.550551 250.257 2.23857 244C16.0942 251 90.0254 205.297 95.5015 185C65.9826 155.432 39.7092 155.754 16.0942 135.056C92.843 108.445 116.458 83.3124 86.939 59.6578C57.4206 36.0034 30.8536 16.7842 7.23857 2.00024"
          stroke="#D4A574"
          strokeWidth="4"
          strokeLinecap="round"
          strokeDasharray="15 10"
        />
      </svg>
      {options.map((option) => (
        <Option
          key={option.label}
          image={option.image}
          label={option.label}
          color={option.color}
          className={option.className}
          to={option.to}
        />
      ))}
    </div>
  );
}
